import { Component, Input, OnInit } from "@angular/core";
import {
  CustomColumnComponent,
  SharedModule,
  DataService,
} from "@bb-vendure/admin-ui/core";
import { take, Observable } from "rxjs";
import { GetRefundRequestFromOrderDocument } from "src/generated-gql/graphql";

@Component({
  imports: [SharedModule],
  templateUrl: "./refund-state-column.component.html",
  standalone: true,
})
export class RefundStateColumnComponent
  implements CustomColumnComponent, OnInit
{
  constructor(private dataService: DataService) {}

  refundRequest$: Observable<any>;

  ngOnInit(): void {
    this.refundRequest$ = this.dataService
      .query(GetRefundRequestFromOrderDocument, {
        orderId: this.rowItem.id,
      })
      .mapSingle((res) => res.findLatestRefundRequestByOrderId);
  }

  refundParam(id?: number) {
    return {
      filters: `id:eq,${id}`,
    };
  }
  @Input() rowItem: { id: string };
}
